import React, { memo, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import AutoSizer from "react-virtualized-auto-sizer";

import { getFromApiAsync } from '../../helpers/apiHelper';
import { priceToNumber, formatNumberToB_N1, formatNumber_N1, formatNumber } from '../../helpers/utils';

export default memo(function IDXForeignTrade(props) {

    const { indexCode } = props;
    const [indexesHist, setIndexesHist] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const refIndexCode = useRef(null);

    const {t} = useTranslation();
    
    // Neu ngay bat he thong la ngay gd thi lay them trong ngay. Con lai lay hist
    const startupDate = useSelector(state => state.gShared.startupDate ?? '');
    const tradingDate = useSelector(state => state.gShared.tradingDate ?? '');
    const vnTradingDate = (new Date(tradingDate)).toLocaleDateString('en-GB');

    const i_counter = useSelector(state => state.gIndex.indexInfos.find(item => startupDate === tradingDate && item.indexCode === indexCode)?.counter);
    const indexInfo = useSelector(state => state.gIndex.indexInfos.find(item => startupDate === tradingDate && item.indexCode === indexCode) ?? {});

    let displayDatas = [...indexesHist];
    if(indexInfo && tradingDate !== "" && displayDatas.findIndex(x => x.tradingDate === vnTradingDate) < 0) {
        displayDatas.splice(0, 0, {
            tradingDate: vnTradingDate,
            buyForeignQtty: indexInfo.buyForeignQtty,
            sellForeignQtty: indexInfo.sellForeignQtty,
            subForeignQtty: indexInfo.subForeignQtty,
            buyForeignValue: indexInfo.buyForeignValue,
            sellForeignValue: indexInfo.sellForeignValue,
            subForeignValue: indexInfo.subForeignValue,
        })
    }

    //
    const _getDatas = (getIndexCode) => {
        if(isLoading) return;

        setIsLoading(true);

        // Init call api get data
        getFromApiAsync("pr/indexhist/" + getIndexCode).then(res => {
            if(getIndexCode === refIndexCode.current) {
                setIndexesHist(res.data);
                setIsLoading(false);
            }
        }).catch(err => {
            setIsLoading(false);
        });
    }

    const _getColorByValue = (value) => {
        return priceToNumber(value) > 0 ? "clr-up" : priceToNumber(value) < 0 ? "clr-down" : "";
    } 

    //
    useEffect(() => {
        if(refIndexCode.current != indexCode) {
            setIsLoading(false);
            setIndexesHist([]);
        }
        refIndexCode.current = indexCode;
        _getDatas(indexCode);
    }, [indexCode]);

    //
    return (
        <>
        <AutoSizer>
            {({ height, width }) => {
                return (
                    <div className="tbl__popup" style={{height: height, width: width}}>
                        <div className="scroll-styled">
                            <table className="tb-sticky sticky-left">
                                <thead>
                                    <tr>
                                        <th className="text-left">{t('ngay')}</th>
                                        <th className="text-right" style={{width: '13%'}}>{t('klMua')}</th>
                                        <th className="text-right" style={{width: '13%'}}>{t('klBan')}</th>
                                        <th className="text-right" style={{width: '13%'}}>{t('klRong')}</th>
                                        <th className="text-right" style={{width: '17%'}}>{t('gtMua')}</th>
                                        <th className="text-right" style={{width: '17%'}}>{t('gtBan')}</th>
                                        <th className="text-right" style={{width: '17%'}}>{t('gtRong')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {displayDatas && displayDatas.length > 0 && displayDatas.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className={"text-left"}>{item.tradingDate}</td>
                                            <td className={"text-right clr-up"}>{formatNumber_N1(item.buyForeignQtty)}</td>
                                            <td className={"text-right clr-down"}>{formatNumber_N1(item.sellForeignQtty)}</td>
                                            <td className={clsx("text-right", _getColorByValue(item.subForeignQtty))}>{formatNumber_N1(item.subForeignQtty)}</td>
                                            <td className={"text-right clr-up"}>{formatNumber_N1(item.buyForeignValue)}</td>
                                            <td className={"text-right clr-down"}>{formatNumber_N1(item.sellForeignValue)}</td>
                                            <td className={clsx("text-right", _getColorByValue(item.subForeignValue))}>{formatNumber_N1(item.subForeignValue)}</td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            }}
        </AutoSizer>
        </>
    )
}, (prevProps, nextProps) => {
    if (prevProps.indexCode === nextProps.indexCode) {
        return true;
    }
    return false;
})